import React from 'react'
import LinkActionButton from '../../Buttons/LinkActionButton'
import SubmitSpinner from '../../Spinners/SubmitSpinner'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_DeleteButton.scss'
import PropTypes from 'prop-types';

class DeleteButton extends React.Component {
  static propTypes = {
    startDeleting: PropTypes.func,
    submitting: PropTypes.bool
  };

  render () {
    return (
      <span>
        { !this.props.submitting && <LinkActionButton size={'small'} onClick={this.props.startDeleting} className={styles['no-padding']} title={'Delete'} buttonText='Delete' /> }
        { this.props.submitting && <SubmitSpinner /> }
      </span>
    )
  }
}

export default (DeleteButton)
